<script setup lang="ts">
import { useVuelidate } from '@vuelidate/core'
import { required, alpha, alphaNum, maxLength } from '@vuelidate/validators'

import { countries, type TCountryCode } from 'countries-list'

import Barcode from '@material-symbols/svg-400/rounded/barcode_scanner.svg'
import ChevronRight from '@material-symbols/svg-400/rounded/chevron_right.svg'
import Globe from '@material-symbols/svg-400/rounded/globe.svg'

import TextInput from './form_inputs/TextInput.vue'
import SelectInput from './form_inputs/SelectInput.vue'

import { ref } from 'vue'

import { state } from '../state'

const emit = defineEmits<{
  (event: 'onClickNext'): void
}>()

const rules = {
  country: { required, alpha, maxLength: maxLength(3) },
  barcode: { required, alphaNum, maxLength: maxLength(30) }
}

const v$ = useVuelidate(rules, state)

async function onSubmit() {
  if (await v$.value.$validate()) {
    emit('onClickNext')
  }
}

const countryCodes = Object.keys(countries) as TCountryCode[]
const itemMapping: { code: TCountryCode; name: string }[] = countryCodes
  .map((code) => ({
    code: code,
    name: countries[code].name
    // icon: Globe,
  }))
  .sort((a, b) => a.name.localeCompare(b.name))
const items = ref(itemMapping)
</script>

<template>
  <form @submit.prevent @submit="onSubmit">
    <div class="space-y-0">
      <div>
        <TextInput
          id="barcode"
          v-model="state.barcode"
          :icon="Barcode"
          label="Barcode"
          placeholder="Barcode"
          :errors="v$.barcode.$errors.map<any>((e) => e.$message)"
        />
      </div>
      <div>
        <SelectInput
          id="country"
          v-model="state.country"
          :icon="Globe"
          :items="items"
          item-title="name"
          item-value="code"
          label="Country"
          placeholder="Country"
          :errors="v$.country.$errors.map<any>((e) => e.$message)"
        />
      </div>
    </div>
    <div class="flex justify-end my-4 text-sm">
      <button class="btn-next" type="submit">
        Next
        <ChevronRight class="w-6 h-6 ml-2" />
      </button>
    </div>
  </form>
</template>
